import Principal from './Principal';
import DadosGerais from './DadosGerais';
import Gerenciamento from './Gerenciamento';

export default [
    {
        id: 'principal',
        title : "Principal",
        icon : "",
        order : 0,
        children : Principal,
        header : true,
        role : [],
        expand:false
    },
    {
        id: 'dados-gerais',
        title : "Dados gerais",
        icon : "",
        order : 1,
        children : DadosGerais,
        header : true,
        role : [],
        expand:false
    },
    {
        id: 'gerenciamento',
        title : "Gerenciamento",
        icon : "",
        order : 2,
        children : Gerenciamento,
        header : true,
        role : [],
        expand:false,
        funcao : (ctx) => {
            return ctx.$store.state.app.selectedCompanyObj != null;
        }
    }
]